module.exports = __webpack_public_path__ + "static/media/NLD.289db54f.svg";